import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS8 = props => {
    const ans = '內向行為'
    const select_arr = [
        {
            value: '1',
            label: '謹慎'
        },
        {
            value: '2',
            label: '文靜'
        },
        {
            value: '3',
            label: '自信'
        },
        {
            value: '4',
            label: '情緒穩定'
        },
        {
            value: '5',
            label: '畏縮'
        },
        {
            value: '6',
            label: '過份沉默'
        },
        {
            value: '7',
            label: '過份依賴'
        },
        {
            value: '8',
            label: '多愁善感'
        },

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s8"
                   type="checkbox"/>
        </div>
    )
}

export default SseS8


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS8.jsx